import script from "./YearlyCalendarView.vue?vue&type=script&setup=true&lang=js"
export * from "./YearlyCalendarView.vue?vue&type=script&setup=true&lang=js"

import "./YearlyCalendarView.vue?vue&type=style&index=0&id=bd067d18&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd067d18"]])

export default __exports__